import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ContactoModel } from '../models/contacto-model';

@Injectable({
  providedIn: 'root'
})
export class ContactosService {

  constructor(protected http: HttpClient, @Inject('BASE_URL') protected baseUrl: string) { }

  getContactos(): Observable<ContactoModel[]> {
    return this.http.get<ContactoModel[]>(`${this.baseUrl}api/Contacto/`);
  }

  getContactosByPrescriptor(prescriptorId: any) {
    if (!prescriptorId) {
      prescriptorId = '';
    }
    let params = new HttpParams()
      .set('prescriptorId', prescriptorId)
    return this.http.get(`${this.baseUrl}api/Contacto/PrescriptorId`, { params });
  }

  getContactoById(id: number) {
    return this.http.get(`${this.baseUrl}api/Contacto/${id}`);
  }

  post(item, prescriptorId): Observable<ContactoModel> {
    if (!prescriptorId) {
      prescriptorId = '';
    }
    let params = new HttpParams()
      .set('prescriptorId', prescriptorId)

    return this.http.post<ContactoModel>(`${this.baseUrl}api/Contacto`, item, { params });
  }

  put(item): Observable<ContactoModel> {
    const url = `${this.baseUrl}api/Contacto/${item.id}`;
    console.log("put: " + url);
    return this.http.put<ContactoModel>(url, item);
  }

  delete(id: number, prescriptorId: any) {
    if (!prescriptorId) {
      prescriptorId = '';
    }
    let params = new HttpParams()
      .set('id', id.toString())
      .set('prescriptorId', prescriptorId)
    return this.http.delete<ContactoModel>(`${this.baseUrl}api/Contacto`, { params });
  }

  postPrecriptorContacto(item, prescriptorId): Observable<ContactoModel> {
    if (!prescriptorId) {
      prescriptorId = '';
    }

    console.log(item)
    console.log(prescriptorId)
    let params = new HttpParams()
      .set('prescriptorId', prescriptorId)

    return this.http.post<ContactoModel>(`${this.baseUrl}api/Contacto/prescriptor-relacion`, item, { params });
  }

  deletePrescriptoContacto(id: number, prescriptorId: any) {
    if (!prescriptorId) {
      prescriptorId = '';
    }
    let params = new HttpParams()
      .set('id', id.toString())
      .set('prescriptorId', prescriptorId)
    return this.http.delete<ContactoModel>(`${this.baseUrl}api/Contacto/prescriptor-relacion`, { params });
  }


}
